<template>
    <v-text-field
        v-model="formInput"
        :label="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"
        dense
        outlined
        rounded
        :disabled="isReadonly || $attrs.disabled"
        :error-messages="errorMessage"
        v-bind="$attrs"
        :hint="$attrs.type === 'number' && !$attrs.hint ? t('patients::form.numeric.hint') : $attrs.hint"
        :persistent-hint="($attrs.type === 'number' && !$attrs.hint) || $attrs['persistent-hint']"
        background-color="#fff"
        @change="resetErrorMessage($event)"
        v-on="$listeners"
        @keydown="$attrs.type === 'number' ? preventNonNumericalInput($event) : false"
    >
        <template #label>
            <span v-html="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"></span>
        </template>
    </v-text-field>
</template>

<script>
export default {
    name: 'BInput',
    props: {
        toMutate: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        isNumber: {
            type: Boolean,
            required: false,
            default: false,
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            store: null,
            propertyToMutate: null,
        };
    },
    computed: {
        formInput: {
            get() {
                return _.get(this.$store.state[this.store], this.propertyToMutate);
            },
            set(value) {
                if (this.isNumber && !isNaN(value) && value !== '') {
                    value = Number.parseFloat(value);
                }
                this.$store.dispatch(`${this.store}/updateProperty`, { value, property: this.propertyToMutate });
            },
        },
        errorMessage() {
            const propertyToMutate =
                this.propertyToMutate !== this.toMutate.split('::')[1]
                    ? this.toMutate.split('::')[1]
                    : this.propertyToMutate;
            return _.get(this.$store.state[this.store].errorMessages, propertyToMutate);
        },
        isReadonly() {
            if (typeof this.$attrs.readonly !== 'undefined') {
                return this.$attrs.readonly;
            }

            if (this.filters) {
                return false;
            }

            if (this.forceReadonly) {
                return true;
            }

            const propertyToMutate = this.propertyToMutate.toString().split('.').slice(-2).join('.');

            if (!is_writeable(propertyToMutate)) {
                return true;
            }

            return false;
        },
    },
    created() {
        [this.store, this.propertyToMutate] = this.toMutate.split('::');
    },
    methods: {
        preventNonNumericalInput(e) {
            e = e || window.event;
            const isIntegerMode = !!this.$attrs.integer;
            const key = e.which || e.keyCode;
            const ctrl = e.ctrlKey ? e.ctrlKey : key === 17 || key === 91 ? true : false;
            const allowedCharacters = ['.', ',', 'Backspace', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const allowedCharactersIntegerMode = [
                'Backspace',
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'Tab',
            ];
            // case Integer Mode
            if (isIntegerMode) {
                if (!!key && ctrl) return;
                if (!e.key.match(/^[0-9]+$/) && !allowedCharactersIntegerMode.includes(e.key)) e.preventDefault();
                return;
            }
            // case Control OR Command Pressed
            if (!!key && ctrl) return;
            if (!e.key.match(/^[0-9]+$/) && !allowedCharacters.includes(e.key)) e.preventDefault();
        },
        resetErrorMessage() {
            if (this.errorMessage) {
                this.$store.commit(`${this.store}/SET_ERROR_MESSAGE`, {
                    value: [],
                    property: this.propertyToMutate,
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.v-input::v-deep {
    .v-label {
        margin-bottom: 0 !important;
    }
}
</style>
